module.exports = __webpack_public_path__ + "static/2-2-371295de4b04e61775819cac70e14b3a.jpg";